export const environment = {
  API_HOST_URL: '/api',
  production: false,
};
